import gql from 'graphql-tag';

const GET_ALL = gql`
    query all($perPage: Int!,$page: Int, $orderBy: [NotifikasiOrderByOrderByClause!], $where: NotifikasiWhereWhereConditions){
        notifikasi(first: $perPage, page: $page, orderBy: $orderBy, where: $where){
            data{
                id
                uuid,
                judul,
                konten,
                halaman,
                created_at,
                ikon,
                is_read,
                notifikasiable_uuid,
                pengguna{
                    id
                    nama
                }
                notifikasi{
                    ... on Agenda {
                        __typename
                        uuid
                        judul
                    }
                    ... on Surat {
                        __typename
                        uuid
                        perihal 
                        isi_ringkas
                    }
                }
            }
            paginatorInfo{
              count
              total
              hasMorePages
              currentPage
              lastPage
              perPage
            }
        }
    }
`;

const GET_COUNT = gql `
  query all(
    $perPage: Int!
    $page: Int
    $orderBy: [NotifikasiOrderByOrderByClause!]
    $where: NotifikasiWhereWhereConditions
  ) {
    notifikasi(first: $perPage, page: $page, orderBy: $orderBy, where: $where) {
      paginatorInfo {
        count
        total
      }
    }
  }
`;

const GET_DETAIL = gql`
    query find($id: String!){
        notifikasiByUuid(uuid : $id){
            id,
            uuid,
            judul,
            konten,
            halaman,
            is_read,
            notifikasiable_uuid,
            pengguna {
              id
              nama
            }
            created_at
        }
    }
`;

const UPDATE = gql`
    mutation($id: ID!, $input:NotifikasiUpdateInput!){
        notifikasiUpdate(id:$id, input:$input){
            uuid,
        }
    }
`

const DELETE = gql `
  mutation notifikasiDelete($id: ID!){
    notifikasiDelete(id: $id){
      uuid
    }
  }
`

export {
    GET_ALL,
    GET_DETAIL,
    GET_COUNT,
    UPDATE,
    DELETE,
}